import xieyi from '@/components/xieyi'
import AutoForm from '@/components/AutoForm'

export default {
  components: {
    xieyi, AutoForm
  },
  props: {
    withStep: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '用户注册'
    }
  },
  data() {
    // 再次输入密码验证
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.Password) {
        callback(new Error('两次输入的密码不一致!'));
      } else {
        callback();
      }
    };
    // 证件号码格式验证
    let validateConfirmIdCard = (rule, value, callback) => {
      if(!this.withStep && !this.formChange.ContractsCardNumber) {
        callback();
      }
      else {
        switch (this.form.ContractsCardType) {
          case 0: // 
            validateIdCard(rule, value, callback);
            break;
          case 1:
            validatePassport(rule, value, callback);
            break;
          case 2:
            validateMilitaryCard(rule, value, callback);
            break;
          case 9:
            validateHMPassCard(rule, value, callback);
            break;
        }
      }
    };

    // 银行卡号
    let validateBankcard2 = (rule, value, callback) => {
      if(!this.withStep && !this.formChange.Account) {
        callback();
      //}
      // else if (!this.bankIsOk) {
      //   callback(new Error('您输入的银行卡号暂不支持！'));
      } else {
        validateBankcard(rule, value, callback);
      }
    }

    let validatePhone2 = (rule, value, callback) =>  {
      if(!this.withStep) {
        callback();
      }
      else {
        validatePhone(rule, value, callback);
      }
    }

    return {
      xieyiVisible: false,
      url: {
        loadData: SZH.assets.api + "/Authen/GetCustomInfo",
        saveData: SZH.assets.api + "/Authen/ModifyCustomInfo",
        save: SZH.assets.api + "/Authen/RegisterAccount",
        get: SZH.assets.api + "/Authen/GetAllSaleMan",
        province: SZH.assets.api + "/Market/GetSelectProvince",
        city: SZH.assets.api + "/Market/GetSelectCity",
        bank: SZH.assets.api + "/Market/GetSelectBaseBank",
        bankBranch: SZH.assets.api + "/Market/GetSelectBankInfo",
        bankSearch: SZH.assets.api + "/Market/GetBankMapping",
        vUserName: SZH.assets.api + "/Authen/VerifyUserName",
        vCustomName: SZH.assets.api + "/Authen/VerifyCustomName",
        vPhone: SZH.assets.api + "/Authen/VerifyCustomPhoneNum",
        sendVCode: SZH.assets.api + "/Authen/SendVerifyCode",
      },
      form: {
        Id: null,
        Province: null, City: null, Bank: null, CustomId: null, Captcha: '', CustomNo:'',
        UserName: '', EmpName: '', EmpSex: '男', Password: '', RePassword: '', PhoneNumber: '', Name: '', ContractsName: '', SalesUser: '',
        ContractsEmail: '', ContractsCardType: 0, ContractsCardNumber: '', AccountBank: null, Account: '', 
        //IntentionalEnterprises: ['101', '102', '103']
      },
      templateIndex: 0,
      formTemplates: [
        [
          { col: 24, tips: '用户信息', type: 'tips' },
          { col: 24, label: '用户名称', prop: 'Name', tips: '请输入汉字、数字、字母、特殊符号或任意组合。' },
        ],
        [
          { col: 24, tips: '账号信息', type: 'tips' },
          { col: 24, label: '登录账号', prop: 'UserName', tips: '创建一个默认登录账号，用于登录，以数字、字母或数字与字母组合，且长度不低于6个字符。' },
          { col: 24, label: '登录密码', prop: 'Password', type: 'password', tips: '必须包含数字、大写字母、小写字母，且密码不低于8个字符。' },
          { col: 24, label: '确认密码', prop: 'RePassword', type: 'password', tips: '' },
        ],
        [
          { col: 24, tips: '实名认证信息', type: 'tips' },
          { col: 24, label: '姓名', prop: 'EmpName', tips: '用于默认账号的实名认证信息。' },
          /*{ col: 24, label: 'SAP客户号', prop: 'CustomNo', tips: '如果您有SAP客户号，请填写，以方便后续购买等使用。' },*/
          { col: 24, type: 'user-no', label: '证件', tips: '用于默认账号的实名认证信息。', prop: 'ContractsCardNumber', optionProp: 'ContractsCardType', defaultOption: '', change: (v) => { this.onIdCardChange(v); } },
          { col: 24, label: '性别', prop: 'EmpSex', type: 'select', options: [{ label: '男', value: '男' }, { label: '女', value: '女' }] },
          { col: 24, label: '手机号', prop: 'PhoneNumber', tips: '用户绑定的手机号。可用于找回密码等操作。' },
          { col: 24, label: '验证码', prop: 'Captcha', type: 'captcha' },
          { col: 24, label: '短信验证码', prop: 'Vcode', type: 'v-code', click: (c) => { this.sendVcode(c); } },
        ],
      ],
      formTemplate: {
          a1: { col: 24, tips: '用户信息', type: 'tips' },
          a2: { col: 24, label: '用户名称', prop: 'Name' },
          a3: { col: 24, tips: '联系人信息', type: 'tips' },
          a4: { col: 24, label: '姓名', prop: 'EmpName', tips: '' },
          /*a41:{ col: 24, label: 'SAP客户号', prop: 'CustomNo' },*/
          a6: { col: 24, type: 'user-no', label: '证件', prop: 'ContractsCardNumber', optionProp: 'ContractsCardType', defaultOption: '', change: (v) => { this.onIdCardChange(v); } },
          a5: { col: 24, label: '性别', prop: 'EmpSex', type: 'select', options: [{ label: '男', value: '男' }, { label: '女', value: '女' }] },
          a7: { col: 24, label: '手机号', prop: 'PhoneNumber', cannotEidt: true },
          a9: { col: 24, label: '电子邮箱', prop: 'ContractsEmail' },
          a10: { col: 24, tips: '银行账号信息', type: 'tips' },
          a11: { col: 24, label: '银行账号', prop: 'Account', change: (v) => { this.onAccountChange(v); } },
          a12: { col: 24, label: '开户银行', prop: 'Bank', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true },
          a13: { col: 12, label: '开户省份', prop: 'Province', type: 'select', options: [], change: () => { this.loadCity(); }, filterable: true },
          a14: { col: 12, label: '开户地级市', prop: 'City', type: 'select', options: [], change: () => { this.loadBankBranch(); }, filterable: true },
          a15: { col: 24, label: '开户银行支行', prop: 'AccountBank', type: 'select', options: [], filterable: true },
          a16: { col: 24, tips: '意向购买企业', type: 'tips' },
          //a17: { col: 24, label: '意向购买企业', prop: 'IntentionalEnterprises', type: 'checkbox', options: [ { label: '昌邑石化', value: '101' }, { label: '华星石化', value: '102' }, { label: '正和石化', value: '103' }, ] },
          a18: { col: 24, label: '默认业务员', prop: 'SalesUser', type: 'select', options: [] },
      },
      rules: {
        Province: [{ required: true, message: '请选择开户行所在省份', trigger: 'change' }],
        /*CustomNo: [{ min: 10, max: 10, message: 'SAP客户号长度应该为10位', trigger: 'blur' }],*/
        City: [{ required: true, message: '请选择开户行所在城市', trigger: 'change' }],
        Bank: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        AccountBank: [{ required: true, message: '请选择开户银行支行', trigger: 'change' }],
        EmpSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        Name: [
          {
            required: true,
            message: '请输入用户名称',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 50,
            message: '用户名称长度应在 2 到 50 个字符之间',
            trigger: 'blur'
          }
        ],
        Captcha: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ],
        UserName: [
          {
            required: true,
            message: '请输入登录账号',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 25,
            message: '登录账号长度应在 6 到 25 个字符之间',
            trigger: 'blur'
          },
          {
            validator: validateUsername,
            trigger: 'blur'
          }
        ],
        Password: [
          {
            required: true,
            message: '请输入登录密码',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        RePassword: [
          {
            required: true,
            message: '请再次输入密码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        EmpName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          {
            min: 2,
            max: 25,
            message: '姓名长度应在 2 到 25 个字符之间',
            trigger: 'blur'
          }
        ],
        ContractsCardNumber: [
          {
            required: true,
            message: '请输入证件号码',
            trigger: 'blur'
          },
          {
            validator: validateConfirmIdCard,
            trigger: 'blur'
          }
        ],
        PhoneNumber: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: validatePhone2,
            trigger: 'blur'
          }
        ],
        Vcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
          {
            min: 6,
            max: 6,
            message: '短信验证码长度应为6个字符',
            trigger: 'blur'
          }
        ],
        ContractsEmail: [
          {
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        Account: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur'
          },
          {
            validator: validateBankcard2,
            trigger: 'blur'
          }
        ],

      },
      formChange: {
        ContractsCardNumber: false,
        Account: false
      },
      checkbox: false,
      loading: false,
      bankIsOk: true,
    }
  },
  methods: {
    register() {
      this.$refs["form"].submit()
    },
    save() {
      var self = this;
      this.$refs['form'].validate(valid => {
        if (valid) {
          self.$http.post(self.url.saveData, { 
            Data: self.form
          }).then(result => {
            if (result.State == 1) {
              self.$message.success('保存成功！');
            } else {
              self.$message.error('保存失败！');
            }
          }, () => {
            self.$message.error('保存失败，请检查您的网络是否可用。');
          });
        }
        else {
          return false;
        }
      });
    },
    beforeSave() {
      this.loading = true;
      this.form.Password = hex_md5(this.form.Password);
      this.form.RePassword = hex_md5(this.form.RePassword);
    },
    onSaved() {
      this.$message.success("注册成功！");
      this.$router.push({
        path: '/Login'
      })
    },
    GetAllSaleMan() {
      var self = this;
      self.$http.post(self.url.get, {}).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.formTemplate['a18'].options = result.Data;
          self.form.SalesUser = result.Data[0].value;
        } else { }
      }, () => {
      });
    },
    afterSaved() {
      this.loading = false;
    },
    next() {
      var self = this;
      if (self.templateIndex == 0) {
        if(!self.checkbox)
        self.$message.error('请阅读并同意《入市协议》后再进行后续操作！');
        else {
          self.$refs['form'].validateField(['Name'], e1 => {
            if(e1 == null || e1 == '') {
              self.loading = true;
              self.$http.post(self.url.vCustomName, { Data: self.form.Name }).then(result => { 
                if(result) {
                  self.goNext();
                }
                else {
                  self.$message.error('用户名称被别人抢先注册啦，换一个吧！');
                }
                self.loading = false;
              }, () => {
                self.loading = false;
              });
            }
            else {
              return false;
            }
          });
        }
      }
      else if(self.templateIndex == 1) {
        self.$refs['form'].validateField(['UserName'], e1 => {
          if(e1 == null || e1 == '') {
              self.loading = true;
              self.$http.post(self.url.vUserName, { Data: self.form.UserName }).then(result => { 
                if(result) {
                  self.goNext();
                }
                else {
                  self.$message.error('登录账号被别人抢先注册啦，换一个吧！');
                }
                self.loading = false;
              }, () => { 
                self.loading = false;
              });
          }
          else {
            return false;
          }
        });
      }
      else if(self.templateIndex == 2) {
        self.register();
      }
      else {
        self.goNext();
      }
    },
    goNext() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.templateIndex++;
        }
        else {
          return false;
        }
      });
    },
    sendVcode(collback) {
      var self = this;
      var state = false;
      self.$refs['form'].validateField(['PhoneNumber', 'Captcha'], e1 => {
        if(e1 == null || e1 == '') {
          state = true;
        }
        else {
          return false;
        }
      });
      if(state) {
        self.loading = true;
        self.$http.post(self.url.vPhone, { Data: self.form.PhoneNumber }).then(result => { 
          if(result) {
            collback();
            self.$http.post(self.url.sendVCode, { 
              Phone: self.form.PhoneNumber,
              Captcha: self.form.Captcha,
              Template: 2
            }).then(result => { 
              if (result.State == 1) {
                self.sendOk = true;
                self.$message.success("验证码发送成功！");
              } else {
                self.$message.error(result.Message);
                self.$refs['form'].refreshCaptcha();
              }
              self.loading = false;
            }, () => { 
              self.loading = false;
            });
          }
          else {
            self.$message.error('该手机号已注册，更换手机号 或者 直接登录吧！');
            self.loading = false;
          }
        }, () => { });
      }

    },
    loadData() {
      var self = this;
      self.$http.post(self.url.loadData, { }).then(result => {
        if (result.State == 1 && result.Data != null) {
          for(var i in self.form) {
            if(result.Data[i] != undefined && result.Data[i] != null) 
            {
              self.form[i] = result.Data[i];
            }
            else {
              self.form[i] = null;
            }
            if(i == 'Province') {
              self.loadCity();
            }
            if(i == 'Bank') {
              self.loadBankBranch();
            }
          }
        } else {
          self.formTemplate['a12'].options = [];
        }
      }, () => {
      });
    },
    loadProvince() {
      var self = this;
      self.$http.post(self.url.province, {}).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.formTemplate['a13'].options = result.Data;
        } else { }
      }, () => {
      });
    },
    loadCity() {
      var self = this;
      self.form.City = null;
      self.form.AccountBank = null;
      self.$http.post(self.url.city, { Data: self.form.Province }).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.formTemplate['a14'].options = result.Data;
        } else {
          self.formTemplate['a14'].options = [];
        }
      }, () => {
      });
    },
    loadBanks() {
      var self = this;
      self.$http.post(self.url.bank, { Data: self.form.Province }).then(result => {
        if (result.State == 1 && result.Data != null) {
          self.formTemplate['a12'].options = result.Data;
        } else {
          self.formTemplate['a12'].options = [];
        }
      }, () => {
      });
    },
    loadBankBranch() {
      var self = this;
      if (self.form.City != '' && self.form.City != null && self.form.Bank != '' && self.form.Bank != null) {
        self.form.AccountBank = null;
        self.$http.post(self.url.bankBranch, {
          Data: {
            BankId: self.form.Bank,
            CityId: self.form.City,
          }
        }).then(result => {
          if (result.State == 1 && result.Data != null) {
            self.formTemplate['a15'].options = result.Data;
          } else {
            self.formTemplate['a15'].options = [];
          }
        }, () => {
        });
      }
    },
    onIdCardChange(v) {
      var self = this;
      self.formChange.ContractsCardNumber = true;
      if (self.form.ContractsCardType == 0 && v != null && v.length >= 17) {
        self.form.EmpSex = v[16] % 2 == 0 ? '女' : '男'
      }
    },
    onAccountChange(v) {
      var self = this;
      self.formChange.Account = true;
      if (v != null && v.length >= 6) {
        var s = v.substring(0, 6);
        self.$http.post(self.url.bankSearch, {
          Data: s
        }).then(result => {
          if (result.State == 1 && result.Data != null) {
            self.form.Bank = result.Data.BankId;
            self.bankIsOk = true;
            self.loadBankBranch();
          } else {
            self.bankIsOk = false;
          }
        }, () => {
          self.bankIsOk = false;
        });
      }
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    if(!this.withStep) {
      this.GetAllSaleMan();
      this.loadData();
      this.loadBanks();
      this.loadProvince();
    }
  },
  watch: {}
}



// WEBPACK FOOTER //
// ./src/components/UserInfo/userinfo.js